import Phaser from 'phaser'
import ToggleButton, { TOGGLE_SELECTED } from './ToggleButton';

export default class ToggleGroup
{
    /**
     * 
     * @param {ToggleButton[]} toggles 
     */
    constructor(toggles)
    {
        this._toggles = toggles;

        this._toggles.forEach(toggle => toggle.on(TOGGLE_SELECTED, this._selectToggle, this));
    }

    getAnySelected()
    {
        return this._toggles.some(toggle => toggle.isSelected);
    }

    _selectToggle(selectedToggle)
    {
        this._toggles.forEach(toggle =>
        {
            if (toggle !== selectedToggle)
            {
                toggle.deselect();
            }
        });
    }
}